import React  from 'react';

const NoData = () => {
    return ( 
            <tr>
                <td colSpan={10} className="noData">NO DATA TO DISPLAY</td>
            </tr>
     );
}
 
export default NoData;